export default "__VITE_ASSET__AGHIbuG9__"